import React from 'react'
import {
  Button,
  ContainerDimensionsContextProvider,
  Icon,
  Modal,
} from '@therms/atalaya'
import {generatePath} from 'react-router-dom'
import {REPORTS_ROUTES} from '@src/modules/Reports/constants'
import ViewReport from '@src/modules/Reports/components/ViewReport'
import {history} from '@src/App'
import {MdOpenInNew} from 'react-icons/md'

interface ViewReportModalProps {
  closeHandler: () => void
  reportId: string
}

function ViewReportModal({closeHandler, reportId}: ViewReportModalProps) {
  return (
    <Modal
      closeHandler={closeHandler}
      escPressClose
      header={
        <div className="inline-flex w-full items-center justify-between">
          <span className="text-lg">Report</span>

          <Button
            className="cursor-pointer"
            onClick={() => {
              history.push(
                generatePath(REPORTS_ROUTES.VIEW_REPORT, {
                  reportId,
                }),
              )
              closeHandler()
            }}
            subtle
            variant="main"
          >
            <Icon Icon={MdOpenInNew} size="sm" />
          </Button>
        </div>
      }
      width="lg"
    >
      <ContainerDimensionsContextProvider>
        <ViewReport reportId={reportId} />
      </ContainerDimensionsContextProvider>
    </Modal>
  )
}

export {ViewReportModal}